import { ReactElement } from 'react';
import Lang from '@lang/en';
import showNotification from '@root/src/app/designSystem/toastNotification/selectToast';
import { NullableString } from '@root/src/app/common/types';
import useWindowWidth from '@app/common/useWindowWidth';
import getActionButtons from './actionButtons';
import ActionsMobile from './actionsMobile';
import ActionsDesktop from './actionsDesktop';

export type HandlersI = {
  handleAddResultsOpen: () => void;
  handleTestPerformed: () => void;
  handleOrderConfirmed: () => void;
  handleDeleteOrderOpen: () => void;
  handlePreviousStageOrderOpen: () => void;
  handleResendCertificate: () => void;
  handleGenerateCertificate: () => void;
};

const ActionButtons = ({
  state,
  testType,
  handlers,
  isCertificateGenerated,
  isResendCertificate,
  showPreviousStageAndGenerateCertificateButtons,
}: {
  state: string;
  testType: NullableString;
  handlers: HandlersI;
  isCertificateGenerated: boolean;
  isResendCertificate: boolean;
  showPreviousStageAndGenerateCertificateButtons: boolean;
}): ReactElement => {
  const isCertificateTypeDropdownShow = false;

  const { isMobileView } = useWindowWidth();

  const handlersWithNotifications = {
    ...handlers,
    handleOrderConfirmed: handlers.handleOrderConfirmed,
    handleTestPerformed: handlers.handleTestPerformed,
    handleResendCertificate: handlers.handleResendCertificate,
    handleGenerateCertificate: handlers.handleGenerateCertificate,
  };

  const buttons = getActionButtons(handlersWithNotifications);

  return isMobileView ? (
    <ActionsMobile
      isCertificateGenerated={isCertificateGenerated}
      isResendCertificate={isResendCertificate}
      isCertificateTypeDropdownShow={isCertificateTypeDropdownShow}
      handlers={handlersWithNotifications}
      state={state}
      testType={testType}
      buttons={buttons}
      showPreviousStageAndGenerateCertificateButtons={
        showPreviousStageAndGenerateCertificateButtons
      }
    />
  ) : (
    <ActionsDesktop
      isResendCertificate={isResendCertificate}
      isCertificateGenerated={isCertificateGenerated}
      isCertificateTypeDropdownShow={isCertificateTypeDropdownShow}
      state={state}
      handlers={handlersWithNotifications}
      testType={testType}
      buttons={buttons}
      showPreviousStageAndGenerateCertificateButtons={
        showPreviousStageAndGenerateCertificateButtons
      }
    />
  );
};

export default ActionButtons;
